const styles = theme => ({
  adgmDarkbtn: {
    background: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '0px',
    height: '48px',
    minWidth: '222px',
    fontWeight: '600',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
  },
  '@media (max-width: 690px)': {
    container: {
      left: '0px',
    },
  },
});

export default styles;
